import i18n, { InitOptions } from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

import swissGermanTranslations from "./de_CH.json";
import britishEnglishTranslations from "./en_GB.json";

export const SWISS_GERMAN_LOCALE = "de_CH";
export const BRITISH_ENGLISH_LOCALE = "en_GB";
export const AVAILABLE_LOCALES = [SWISS_GERMAN_LOCALE, BRITISH_ENGLISH_LOCALE];

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        lng: SWISS_GERMAN_LOCALE,
        backend: {
            loadPath: "./{{ns}}/{{lng}}.json",
        },
        resources: {
            de_CH: { translations: swissGermanTranslations },
            en_GB: { translations: britishEnglishTranslations },
        },
        fallbackLng: SWISS_GERMAN_LOCALE,
        debug: false,
        ns: ["translations"],
        defaultNS: "translations",
        nsSeparator: false,
        initImmediate: false,
        interpolation: {
            escapeValue: false,
            formatSeparator: ",",
        },
        react: {
            useSuspense: true,
        },
    } as InitOptions);

export default i18n;
